import { CommonModule } from '@angular/common';
import { Component, HostListener, input, output } from '@angular/core';
import { Icon } from '@malirang/front-share';

@Component({
  selector: 'app-content-favorite',
  template: `
    <app-icon
      name="material-symbols:kid-star"
      [ngClass]="
        isFavorite() ? 'text-yellow-500' : 'text-gray-400 hover:text-yellow-300'
      "
      class="transition-colors cursor-pointer hover:opacity-80"
    />
  `,
  imports: [Icon, CommonModule],
})
export class ContentFavoriteComponent {
  isFavorite = input<boolean>();
  favorite = output<void>();

  @HostListener('click', ['$event']) handleClick(ev: any) {
    ev.stopPropagation();
    ev.preventDefault();

    this.favorite.emit();
  }
}
